export default __webpack_public_path__ + "static/media/power-cushion-aero.c3ca4a30.webp";